// introduced because of web components
export enum ListSeparators {
  All = 'All',
  Inner = 'Inner',
  None = 'None'
}
